// extracted by mini-css-extract-plugin
module.exports = {"burgerContainer":"BurgerMenu_burgerContainer__TcWDt","overlay":"BurgerMenu_overlay__jEjYC","menu":"BurgerMenu_menu__IzPYQ","menuItem":"BurgerMenu_menuItem__IHJ96"};